import { render, staticRenderFns } from "./ExpensiveForm.vue?vue&type=template&id=829a1858&"
import script from "./ExpensiveForm.vue?vue&type=script&lang=js&"
export * from "./ExpensiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports